import BaseWebsocketListener from "@spa/apps/trustup-pro-base-js/BaseWebsocketListener";
import TrustUpIOTask from "./models/TrustUpIOTask";

export default class WebsocketListener extends BaseWebsocketListener
{

    init()
    {
        this.echo().channel( this.getChannelName() )
            .listen('.trustup-io-task:task:created', (e) => {
                this.getTask(e.uuid)
                    .then(task => {
                        console.log('trustup-io-task:task:created', e, task);
                        window.App.$bus.$emit('trustup-io-task:task:created', task);
                    });
            })
            .listen('.trustup-io-task:task:updated', (e) => {
                this.getTask(e.uuid)
                    .then(task => {
                        console.log('trustup-io-task:task:updated', e, task);
                        window.App.$bus.$emit('trustup-io-task:task:updated', task);
                    });
            })
            .listen('.trustup-io-task:task:deleted', (e) => {
                console.log('trustup-io-task:task:deleted', e);
                window.App.$bus.$emit('trustup-io-task:task:deleted', e.uuid);
            });
    }

    async getTask(uuid)
    {
        console.log('Get task', uuid);
        let task = await window.TrustUpBase.endpoints.trustupIOTask.retrieve(uuid);
        console.log('Got task', task);
        return task;
    }
    
}